<template>
	<div>

		<v-toolbar flat fixed tabs dark>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Drafts</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn>

		    <v-tabs slot="extension" fixed-tabs centered v-model="activeIndex" color="transparent" slider-color="#4b77be" class="toolbar_tabs fix_width_tabcount2" @input="fn_tabChange">
			    <v-tab v-for="(tab, index) in tabs" :key="index" ripple>{{tab.title}}</v-tab>
			</v-tabs>
		</v-toolbar>


		<div class="hasToolbarAndTabs">

			<div v-if="loading" class="display_msg">
	          	<v-progress-circular indeterminate color="primary"></v-progress-circular>
	        </div>

			<v-tabs-items v-model="activeIndex" @input="fn_tabChange">
		      <v-tab-item>
		        <keep-alive>
		      		<draft-master ref="masterdrafts" :draftItems="filteredMasterDrafts" :functions="PropFunctions" :filterValue="masterFilterValue" :loading="loading"></draft-master>
		      	</keep-alive>
		      </v-tab-item>

		      <v-tab-item>
		        <keep-alive>
		      		<draft-transaction ref="transactiondrafts" :draftItems="filteredTransactionDrafts" :functions="PropFunctions" :filterValue="masterFilterValue" :loading="loading"></draft-transaction>
		      	</keep-alive>
		      </v-tab-item>
		    </v-tabs-items>

		</div>

        <v-dialog v-model="filter_dialog" no-click-animation scrollable persistent content-class="full-height" transition="dialog-bottom-transition">
	      <v-card>
	        <v-card-title>Select Type</v-card-title>
	        <v-divider></v-divider>
	        <v-card-text nopadding single-selection-dialog full-height>
	          	<v-radio-group column form-item v-model="masterFilterValue" full-width-label right-align-radio>
	          		<v-radio :label="item.title" :value="item.value" v-for="(item, index) in itemTypes" :key="index" @change="fn_closeDialog(true, 'filter_dialog')"></v-radio>
	          	</v-radio-group>
	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click="fn_closeDialog(false, 'filter_dialog')">close</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>

	    <v-dialog v-model="dialog_delete_confirmation" no-click-animation persistent transition="slide-y-transition" max-width="290">
	      <v-card>
	        <v-card-title class="title noshadow pb-0">Delete All?</v-card-title>
	        <v-card-text>{{confirmationMessage}}</v-card-text>
	        <v-card-actions>
	          <v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="fn_closeDialog(false, 'dialog_delete_confirmation')">No</v-btn>
	          <v-btn color="blue darken-1" flat @click.native="fn_deleteAllDrafts">Yes</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
let draftTabConfigs = require('../../../config.js').configs.draftTabConfigs;

const menuItem = require('../../../config.js').configs.menuItem;

import draftMaster from './draft_master';
import draftTransaction from './draft_transaction';

let scrollPosY = 0;
	export default{
		data(){
			return{
				draftItems: [],
				masterDraftItems: [],
				transactionDraftItems: [],

				tabs:[
					{"id":1, "title":"Master"},
					{"id":1, "title":"Transaction"}
				],
				itemTypes:[
					{"id":1, "title":"All", "value":""}, 
					{"id":2, "title":"Ledgers", "value":"Ledgers"}, 
					{"id":3, "title":"Groups", "value":"Groups"}, 
					{"id":4, "title":"Products", "value":"Products"}, 
					{"id":5, "title":"Category", "value":"Category"}, 
					{"id":6, "title":"Units", "value":"Units"}, 
					{"id":7, "title":"Lists", "value":"Lists"}, 
					{"id":8, "title":"List Item", "value":"List Item"}, 
					{"id":9, "title":"Taxes", "value":"Taxes"}, 
					{"id":10, "title":"Discounts and Offers", "value":"Discounts and Offers"},
					{"id":11, "title":"Other Charges", "value":"Other Charges"}
				],
				filter_dialog:false,
				dialog_delete_confirmation:false,
				activatedPopover:false,
				loading:false,
				description:"A quick brown fox jumps over the lazy dog.",

				nowdate:null,

				PropFunctions:{},
				PropData:{},
				activeIndex:0,
				currentItemsTitle:null,

				masterFilterValue:"",
				transactionFilterValue:"",
				transactionSearchVal:'',
				masterSearchVal:'',

				confirmationMessage:null
			}
		},
		components:{
			'draft-master': draftMaster,
			'draft-transaction':draftTransaction
		},
		methods:{
			fn_openDraft: function (formPath, item) {
				localStorage.setItem('draftScrollPos', window.pageYOffset);
				// this.$router.push({path:formPath, query:{tagId:item.formId, draft:true}});
				
				if(item.listId){
					this.$router.push({path:'/masters/lists/'+item.listId+'/items/new', query:{tagId:item.formId, listTitle:item.listTitle, draft:true}});
				}
				else{
					this.$router.push({path:formPath, query:{tagId:item.formId, draft:true}});
				}
			},

			fn_openDialog: function (modalValue) {
				this[modalValue] = true;
				scrollPosY = window.scrollY;
				this.fn_fixBackgroundScroll();
			},

			fn_closeDialog: function (scrollTop, modalValue) {
				let spy;
				scrollTop ? spy = 0 : spy = scrollPosY;
				this.fn_removeFixBackgroundScroll(spy);
				this[modalValue] = false;
			},

			fn_discardDraft: function (draftId, index) {
				var self = this;
	            this.deleteData('RemoveDraftById', draftId, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
                        	if(self.activeIndex==0){
								self.masterDraftItems.splice(index, 1);
							}
							else{
								self.transactionDraftItems.splice(index, 1);
							}
	                    }, 
	                    onError: function(error){
	                      console.log(error);
	                    }
	                }
	            );
			},

			fn_getDraftItems: function () {

				let filterObject = {};

				let self = this;
				this.getFilterData('DraftList', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.masterDraftItems = data.masters;
							self.transactionDraftItems = data.transactions;
							self.$forceUpdate();
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );

				this.loading = false;
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Drafts";
				viewObject.TopMenu = [];
				viewObject.isBottomMenu = true;

				var tagId = 'drafts';
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        },
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_getBottomMenu: function (tagId) {
				let bottomMenuItems = [menuItem.deleteAll];

				if((this.activeIndex == 0 && !this.filteredMasterDrafts.length) || 
					(this.activeIndex == 1 && !this.filteredTransactionDrafts.length)){
					bottomMenuItems = [menuItem.help];
				}

				var bottomMenu = {"BottomMenu": bottomMenuItems};
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				if(menuAction=='deleteall'){
					this.fn_openDialog('dialog_delete_confirmation');
					// this.dialog_delete_confirmation = true;
				}
			},

			fn_deleteAllDrafts: function () {
				let removableDrafts = [];

				let dItems = null;
				let type = null;

				if(this.activeIndex == 0){
					dItems = this.masterDraftItems	;
					type = 'Master';			
				}
				else{
					dItems = this.transactionDraftItems;	
					type = 'Transaction'				
				}

				var self = this;
	            this.deleteData('RemoveDraftByType', type, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
                        	if(self.activeIndex==0){
								self.masterDraftItems = [];
							}
							else{
								self.transactionDraftItems = [];
							}
	                    }, 
	                    onError: function(error){
	                      console.log(error);
	                    }
	                }
	            );


				this.fn_closeDialog(false, 'dialog_delete_confirmation');
			},

			fn_tabChange: function (tabIndex) {
        		draftTabConfigs.activeIndex = tabIndex;
				console.log(tabIndex);
			},

			fn_goBack: function(){
				this.$router.go(-1);
			}

		},
		mounted: function () {

			if(draftTabConfigs.activeIndex != null){
		        this.activeIndex = draftTabConfigs.activeIndex;
		        this.fn_tabChange(this.activeIndex);
		    }

			this.PropFunctions.openDialog = this.fn_openDialog;
			this.PropFunctions.openDraft = this.fn_openDraft;
			this.PropFunctions.discardDraft = this.fn_discardDraft;

			this.nowdate = new Date();
			self = this;
			// if(this.$route.query && this.$route.query.category){
			// 	this.masterFilterValue = this.$route.query.category;
			// 	this.activeIndex = this.$route.query.tabIndex;
			// }
			if(this.$route.query){
				this.masterFilterValue = this.$route.query.category ? this.$route.query.category : '';
				this.activeIndex = this.$route.query.tabIndex ? this.$route.query.tabIndex : 0;
			}

			this.fn_showWebView();

			this.fn_getDraftItems();

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_onBackPress = this.fn_goBack;
		},
		computed:{
			filteredMasterDrafts: function () {
				return this.masterDraftItems.filter(item => {
					let itemName = "";
					item.title ? itemName = item.title.toLowerCase() : '';
					this.masterSearchVal = this.$refs['masterdrafts'].searchText.toLowerCase();

					let itemType = "";
					itemType = item.type.toLowerCase();
					let itemTypeValue = this.masterFilterValue.toLowerCase();

					this.filter_dialog = false;
					this.loading = false;

					if(this.activeIndex==0){
						if(this.masterFilterValue || this.masterSearchVal){
	                 		this.confirmationMessage = 'Are you sure you want delete all filtered Items from masters?'
	                 	}
	                 	else{
	                 		this.confirmationMessage = 'Are you sure you want delete all Items from masters?'
	                 	}
					}

					return itemName.match(this.masterSearchVal) && itemType.match(itemTypeValue);
				})
			},
			filteredTransactionDrafts: function () {
				return this.transactionDraftItems.filter(item => {

					let itemName = "";
					item.title ? itemName = item.title.toLowerCase() : '';
					this.transactionSearchVal = this.$refs['transactiondrafts'].searchText.toLowerCase();

					let itemTypeValue = '';

					this.filter_dialog = false;
					this.loading = false;

					if(this.activeIndex==1){
						if(this.transactionFilterValue || this.transactionSearchVal){
	                 		this.confirmationMessage = 'Are you sure you want delete all filtered Items from transactions?'
	                 	}
	                 	else{
	                 		this.confirmationMessage = 'Are you sure you want delete all Items from transactions?'
	                 	}
					}

					// return itemName.match(searchVal) && itemType.match(itemTypeValue);
					return itemName.match(this.transactionSearchVal);
				})
			}
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {
		  		vm.enableToolbar();
		  	})

		  	if(from.name!='actions'){
				setTimeout(function(){
					let srollpos = localStorage.getItem('draftScrollPos');
					window.scrollTo(0, srollpos ? srollpos : 0);
				},1000);
			}
		},
		beforeRouteLeave (to, from, next) {
			// let menuContent = document.getElementsByClassName("menuable__content__activeIndex");
		  	if(this.filter_dialog){
		  		this.fn_closeDialog(false, 'filter_dialog');
		  		next(false);
		  	}
		  	else if(this.dialog_delete_confirmation){
		  		this.fn_closeDialog(false, 'dialog_delete_confirmation');
		  		// this.dialog_delete_confirmation = false;
		  		next(false);
		  	}
		  	// else if(menuContent.length){
		  	// 	menuContent[0].style.display = "none";
		  	// 	menuContent[0].classList.remove("menuable__content__activeIndex");
		  	// 	next(false);
		  	// }
		  	else {
		  		next();
		  	}
		}
		// computed: {
		// 	filteredDraftItems: function () {
		// 		return this.draftItems.sort(function (a, b) {
		// 			return new Date(b.date) - new Date(a.date);
		// 		})
		// 	}
		// }
	}
</script>


// WEBPACK FOOTER //
// src/components/actions/draft/drafts.vue